import {CUSTOM_ELEMENTS_SCHEMA, Injectable, NgModule, NO_ERRORS_SCHEMA} from '@angular/core';
import {CommonModule} from '@angular/common';
import {HTTP_INTERCEPTORS} from '@angular/common/http';
import {ApiInterceptor} from '../../shared/services/interceptor/api.interceptor';
import {JwtParserService} from '../../shared/services/jwt-parser.service';
import {AuthGuard} from '../../shared/services/auth.guard';
import {TooltipModalComponent} from '../../shared/components/tooltip-modal/tooltip-modal.component';
import {ModalService} from '../../shared/services/modal.service';
import {RouterModule} from '@angular/router';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {ManageRewardsRoutingModule} from './manage-rewards-routing.module';
import {ModalModule} from 'ngx-bootstrap/modal';
import {SharedModule} from '../../shared/shared.module';
import {ManageRewardsComponent} from './manage-rewards/manage-rewards.component';
import { LoyaltyBirthdayRewardsComponent } from './loyalty-birthday-rewards/loyalty-birthday-rewards.component';
import { GroceryRewardsComponent } from './grocery-rewards/grocery-rewards.component';
import { PointsHistoryComponent } from './points-history/points-history.component';
import { RewardsToasterComponent } from './rewards-toaster/rewards-toaster.component';
import {RewardService} from '../../shared/services/reward.service';
import {RewardsSummaryService} from '../../shared/services/rewards-summary.service';
import {PaginationService} from '../../shared/services/pagination.service';
import {LoaderService} from '../../shared/loading-spinner/loading-spinner.service';
import {ClipService} from '../../shared/services/clip.service';
import {RewardsToasterService} from '../../shared/services/rewards-toaster.service';
import {PointsCashRewardComponent} from "./points-cash-reward/points-cash-reward.component";
import { PointsScoreCardComponent } from './points-score-card/points-score-card.component';
import { PointRewardGridComponent } from './point-reward-grid/point-reward-grid.component';
import { PointRewardCardComponent } from './point-reward-grid/point-reward-card/point-reward-card.component';
import { PointRewardGridPromotionComponent } from "./point-reward-grid/point-reward-grid-promotion/point-reward-grid-promotion.component";
import { PointRewardDetailComponent } from './point-reward-detail/point-reward-detail.component';
import { CashRewardsBirthdayComponent } from './cash-rewards-birthday/cash-rewards-birthday.component';
import { GetYourRewardsComponent } from './get-your-rewards/get-your-rewards.component';
import { MoreWaysToUseComponent } from './more-ways-to-use/more-ways-to-use.component';
import { BoostYourPointsComponent } from './boost-your-points/boost-your-points.component';
import { OfferQualifiedProductsModule, OfferQualifiedProductsALV1Component } from 'abs-ngx-library/src/lib/offer-qualified-products';
import { CoreModule as AbsCodeModule } from 'abs-ngx-library/src/lib/core';



@NgModule({
    declarations: [
        ManageRewardsComponent,
        LoyaltyBirthdayRewardsComponent,
        GroceryRewardsComponent,
        PointsHistoryComponent,
        RewardsToasterComponent,
        PointsCashRewardComponent,
        PointsScoreCardComponent,
        PointRewardGridComponent,
        PointRewardCardComponent,
        PointRewardGridPromotionComponent,
        PointRewardDetailComponent,
        CashRewardsBirthdayComponent,
        GetYourRewardsComponent,
        MoreWaysToUseComponent,
        BoostYourPointsComponent
    ],
    imports: [
        CommonModule,
        RouterModule,
        FormsModule,
        ReactiveFormsModule,
        ManageRewardsRoutingModule,
        ModalModule.forRoot(),
        SharedModule,
        AbsCodeModule.forRoot({
            programType: 'weeklyAd',
            appName: 'weeklyAd'
        }),
        OfferQualifiedProductsModule,
    ],
    exports: [
    ],
    providers: [JwtParserService, AuthGuard, TooltipModalComponent, {
        provide: HTTP_INTERCEPTORS,
        useClass: ApiInterceptor,
        multi: true
    },
        ModalService, RewardService, RewardsSummaryService, PaginationService, LoaderService, ClipService, RewardsToasterService
        ],
    schemas: [NO_ERRORS_SCHEMA, CUSTOM_ELEMENTS_SCHEMA]
})
export class ManageRewardsModule {
}
